export const getters = {
    getEmpresa: state => state.empresa,
    getEmpresas: state => state.empresas,
    getModalCadastroEmpresa: state => state.modalCadastrarEmpresa,
    getModalExcluirEmpresa: state => state.modalExcluirEmpresa,
    getModalPesquisarEmpresa: state => state.modalPesquisarEmpresa
}

export default {}